import { Component } from 'react';

import './MediaModal.css';
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';


interface Props {
    chartData: { url: string, info: string }
}
interface State {
    opened: boolean
}


export default class MediaModal extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            opened: false
        }
    }

    render() {
        return (
            <>
                <i className="fas fa-circle-question" onClick={this.openModal} />

                {
                    <Modal
                        className="small"
                        opened={this.state.opened}
                        close={this.closeModal}
                    >
                        <div className="modal-title">
                            Interactive Chart <ModalClose close={this.closeModal} />
                        </div>
                        <div className="modal-content">
                            <div dangerouslySetInnerHTML={{ __html: (this.props.chartData.info) }} />
                            <video width="100%" height="auto" src={`/api/user-manager/v1/files/media/${this.props.chartData.url}`} controls>
                                Your browser does not support the video.
                            </video>
                        </div>
                    </Modal>
                }

            </>
        );
    }

    closeModal = () => this.setState({ opened: false });
    openModal = () => this.setState({ opened: true });
};